module.exports = __webpack_public_path__ + "static/GhettYoTacoScreenshot-e01534f8ed0b1d48e88e50f9bdea903c.png";